const baseStyle = {
  maxWidth: '100%',
  height: '100%',
  width: 'auto',
};

export default { baseStyle };
